import React from "react";

const BlinkingDownArrow = () => {
  return (
    <div className="blinking-down-arrow-container">
      <div className="blinking-down-arrow"></div>
    </div>
  );
};

export default BlinkingDownArrow;
